// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_solution.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * SAD-497 SOL-01: a Pursuit's working Solution Concept. Revisions are
 * immutable; the head is the highest revision. Trace links record whether the
 * source STATES a need or the team INFERRED a response.
 *
 * @generated from message mono.projectdata.v1.CaptureSolutionTraceLink
 */ export class CaptureSolutionTraceLink extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionTraceLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionTraceLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionTraceLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionTraceLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * customer_theme | request_document | touchpoint | sme_note | prior_material | pp_evidence | teammate_evidence | attachment
   *
   * @generated from field: string source_kind = 2;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 3;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string source_label = 4;
   */ _define_property(this, "sourceLabel", ""), /**
   * stated | inferred
   *
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * supports | contradicts
   *
   * @generated from field: string stance = 6;
   */ _define_property(this, "stance", ""), /**
   * @generated from field: string excerpt = 7;
   */ _define_property(this, "excerpt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionTraceLink, "runtime", proto3);
_define_property(CaptureSolutionTraceLink, "typeName", "mono.projectdata.v1.CaptureSolutionTraceLink");
_define_property(CaptureSolutionTraceLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SAD-498 SOL-02: a typed content item. kind is the team's own judgement of
 * where the content comes from; a draft source stays draft however explicit.
 *
 * @generated from message mono.projectdata.v1.CaptureSolutionItem
 */ export class CaptureSolutionItem extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionItem, a, b);
    }
    constructor(data){
        super(), /**
   * Stable across revisions so history can be compared item by item.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * source_backed_need | inferred_need | internal_assumption | unknown
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string text = 3;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string source_label = 4;
   */ _define_property(this, "sourceLabel", ""), /**
   * YYYY-MM-DD, empty when undated.
   *
   * @generated from field: string source_date = 5;
   */ _define_property(this, "sourceDate", ""), /**
   * draft | final; required for source_backed_need, empty otherwise.
   *
   * @generated from field: string source_status = 6;
   */ _define_property(this, "sourceStatus", ""), /**
   * high | medium | low | empty (not assessed)
   *
   * @generated from field: string confidence = 7;
   */ _define_property(this, "confidence", ""), /**
   * unvalidated | validated | invalidated
   *
   * @generated from field: string validation_status = 8;
   */ _define_property(this, "validationStatus", ""), /**
   * Empty means NOT STATED, never zero. Must be empty when kind is unknown.
   *
   * @generated from field: string quantity = 9;
   */ _define_property(this, "quantity", ""), /**
   * Why this item changed relative to the prior revision. Required on change.
   *
   * @generated from field: string edit_basis = 10;
   */ _define_property(this, "editBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionItem, "runtime", proto3);
_define_property(CaptureSolutionItem, "typeName", "mono.projectdata.v1.CaptureSolutionItem");
_define_property(CaptureSolutionItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "validation_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "edit_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureSolutionComponentRef
 */ export class CaptureSolutionComponentRef extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionComponentRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionComponentRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionComponentRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionComponentRef, a, b);
    }
    constructor(data){
        super(), /**
   * task | pp_reference | capability | staffing | evidence | teammate
   *
   * @generated from field: string ref_kind = 1;
   */ _define_property(this, "refKind", ""), /**
   * Canonical id for task, pp_reference and capability (validated); optional otherwise.
   *
   * @generated from field: string ref_id = 2;
   */ _define_property(this, "refId", ""), /**
   * Resolved from the canonical record on read; stored only for the non-canonical kinds.
   *
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionComponentRef, "runtime", proto3);
_define_property(CaptureSolutionComponentRef, "typeName", "mono.projectdata.v1.CaptureSolutionComponentRef");
_define_property(CaptureSolutionComponentRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ref_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "ref_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureSolutionComponent
 */ export class CaptureSolutionComponent extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionComponent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionComponent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionComponent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionComponent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * technical | operational | management | transition
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string purpose = 4;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: string proposed_approach = 5;
   */ _define_property(this, "proposedApproach", ""), /**
   * CaptureSolutionItem ids in the same revision.
   *
   * @generated from field: repeated string needs_addressed = 6;
   */ _define_property(this, "needsAddressed", []), /**
   * @generated from field: string provider = 7;
   */ _define_property(this, "provider", ""), /**
   * @generated from field: repeated string open_questions = 8;
   */ _define_property(this, "openQuestions", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionComponentRef refs = 9;
   */ _define_property(this, "refs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionComponent, "runtime", proto3);
_define_property(CaptureSolutionComponent, "typeName", "mono.projectdata.v1.CaptureSolutionComponent");
_define_property(CaptureSolutionComponent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposed_approach",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "needs_addressed",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "open_questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "refs",
            kind: "message",
            T: CaptureSolutionComponentRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureSolutionRevision
 */ export class CaptureSolutionRevision extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionRevision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionRevision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionRevision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionRevision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: int64 revision = 3;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: string approach = 4;
   */ _define_property(this, "approach", ""), /**
   * @generated from field: string intended_outcomes = 5;
   */ _define_property(this, "intendedOutcomes", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string constraints = 7;
   */ _define_property(this, "constraints", ""), /**
   * @generated from field: string unresolved_issues = 8;
   */ _define_property(this, "unresolvedIssues", ""), /**
   * Rationale the team could not source; always shown as an assumption.
   *
   * @generated from field: repeated string assumptions = 9;
   */ _define_property(this, "assumptions", []), /**
   * @generated from field: string change_note = 10;
   */ _define_property(this, "changeNote", ""), /**
   * Set when this revision was created by restoring an earlier one.
   *
   * @generated from field: optional int64 restored_from_revision = 11;
   */ _define_property(this, "restoredFromRevision", void 0), /**
   * @generated from field: string actor_user_id = 12;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionTraceLink trace_links = 13;
   */ _define_property(this, "traceLinks", []), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionItem items = 15;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionComponent components = 16;
   */ _define_property(this, "components", []), /**
   * Accepting the internal approach never changes any item's source_status.
   *
   * @generated from field: bool approach_accepted = 17;
   */ _define_property(this, "approachAccepted", false), /**
   * SAD-504: set when this revision applied an AI suggestion (empty for manual saves).
   *
   * @generated from field: string applied_suggestion_id = 18;
   */ _define_property(this, "appliedSuggestionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionRevision, "runtime", proto3);
_define_property(CaptureSolutionRevision, "typeName", "mono.projectdata.v1.CaptureSolutionRevision");
_define_property(CaptureSolutionRevision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "approach",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "intended_outcomes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "constraints",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "unresolved_issues",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "assumptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "restored_from_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 12,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "trace_links",
            kind: "message",
            T: CaptureSolutionTraceLink,
            repeated: true
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "items",
            kind: "message",
            T: CaptureSolutionItem,
            repeated: true
        },
        {
            no: 16,
            name: "components",
            kind: "message",
            T: CaptureSolutionComponent,
            repeated: true
        },
        {
            no: 17,
            name: "approach_accepted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 18,
            name: "applied_suggestion_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureSolutionRequest
 */ export class GetCaptureSolutionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionRequest, "runtime", proto3);
_define_property(GetCaptureSolutionRequest, "typeName", "mono.projectdata.v1.GetCaptureSolutionRequest");
_define_property(GetCaptureSolutionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureSolutionResponse
 */ export class GetCaptureSolutionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureSolutionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureSolutionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureSolutionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureSolutionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Newest first. Empty until the first revision is saved.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionRevision revisions = 1;
   */ _define_property(this, "revisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureSolutionResponse, "runtime", proto3);
_define_property(GetCaptureSolutionResponse, "typeName", "mono.projectdata.v1.GetCaptureSolutionResponse");
_define_property(GetCaptureSolutionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "revisions",
            kind: "message",
            T: CaptureSolutionRevision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureSolutionRevisionRequest
 */ export class SaveCaptureSolutionRevisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureSolutionRevisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureSolutionRevisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureSolutionRevisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureSolutionRevisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionRevision content = 5;
   */ _define_property(this, "content", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureSolutionRevisionRequest, "runtime", proto3);
_define_property(SaveCaptureSolutionRevisionRequest, "typeName", "mono.projectdata.v1.SaveCaptureSolutionRevisionRequest");
_define_property(SaveCaptureSolutionRevisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "content",
            kind: "message",
            T: CaptureSolutionRevision
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveCaptureSolutionRevisionResponse
 */ export class SaveCaptureSolutionRevisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveCaptureSolutionRevisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveCaptureSolutionRevisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveCaptureSolutionRevisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveCaptureSolutionRevisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionRevision revision = 1;
   */ _define_property(this, "revision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveCaptureSolutionRevisionResponse, "runtime", proto3);
_define_property(SaveCaptureSolutionRevisionResponse, "typeName", "mono.projectdata.v1.SaveCaptureSolutionRevisionResponse");
_define_property(SaveCaptureSolutionRevisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "revision",
            kind: "message",
            T: CaptureSolutionRevision
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RestoreCaptureSolutionRevisionRequest
 */ export class RestoreCaptureSolutionRevisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RestoreCaptureSolutionRevisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreCaptureSolutionRevisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreCaptureSolutionRevisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreCaptureSolutionRevisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: int64 expected_revision = 4;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: int64 source_revision = 5;
   */ _define_property(this, "sourceRevision", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreCaptureSolutionRevisionRequest, "runtime", proto3);
_define_property(RestoreCaptureSolutionRevisionRequest, "typeName", "mono.projectdata.v1.RestoreCaptureSolutionRevisionRequest");
_define_property(RestoreCaptureSolutionRevisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "source_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RestoreCaptureSolutionRevisionResponse
 */ export class RestoreCaptureSolutionRevisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RestoreCaptureSolutionRevisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreCaptureSolutionRevisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreCaptureSolutionRevisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreCaptureSolutionRevisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionRevision revision = 1;
   */ _define_property(this, "revision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreCaptureSolutionRevisionResponse, "runtime", proto3);
_define_property(RestoreCaptureSolutionRevisionResponse, "typeName", "mono.projectdata.v1.RestoreCaptureSolutionRevisionResponse");
_define_property(RestoreCaptureSolutionRevisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "revision",
            kind: "message",
            T: CaptureSolutionRevision
        }
    ]));
/**
 * An assumption version is the immutable source revision plus its stable item ID.
 *
 * @generated from message mono.projectdata.v1.CaptureSolutionAssumptionVersion
 */ export class CaptureSolutionAssumptionVersion extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionAssumptionVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionAssumptionVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionAssumptionVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionAssumptionVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string revision_id = 1;
   */ _define_property(this, "revisionId", ""), /**
   * @generated from field: string item_id = 2;
   */ _define_property(this, "itemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionAssumptionVersion, "runtime", proto3);
_define_property(CaptureSolutionAssumptionVersion, "typeName", "mono.projectdata.v1.CaptureSolutionAssumptionVersion");
_define_property(CaptureSolutionAssumptionVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureSolutionHandoffAssumption
 */ export class CaptureSolutionHandoffAssumption extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionHandoffAssumption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionHandoffAssumption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionHandoffAssumption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionHandoffAssumption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionAssumptionVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionItem item = 2;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: string actor_user_id = 3;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string change_note = 5;
   */ _define_property(this, "changeNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionHandoffAssumption, "runtime", proto3);
_define_property(CaptureSolutionHandoffAssumption, "typeName", "mono.projectdata.v1.CaptureSolutionHandoffAssumption");
_define_property(CaptureSolutionHandoffAssumption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: CaptureSolutionAssumptionVersion
        },
        {
            no: 2,
            name: "item",
            kind: "message",
            T: CaptureSolutionItem
        },
        {
            no: 3,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Immutable upstream intelligence. This does not adopt Proposal content or
 * assert final-solicitation authority. Explicit assumption selections are
 * independent of solution_revision; unselected assumptions are not adopted.
 *
 * @generated from message mono.projectdata.v1.CaptureSolutionHandoff
 */ export class CaptureSolutionHandoff extends Message {
    static fromBinary(bytes, options) {
        return new CaptureSolutionHandoff().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureSolutionHandoff().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureSolutionHandoff().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureSolutionHandoff, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string solution_revision_id = 4;
   */ _define_property(this, "solutionRevisionId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionRevision solution_revision = 5;
   */ _define_property(this, "solutionRevision", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionHandoffAssumption assumptions = 6;
   */ _define_property(this, "assumptions", []), /**
   * @generated from field: string actor_user_id = 7;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureSolutionHandoff, "runtime", proto3);
_define_property(CaptureSolutionHandoff, "typeName", "mono.projectdata.v1.CaptureSolutionHandoff");
_define_property(CaptureSolutionHandoff, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "solution_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "solution_revision",
            kind: "message",
            T: CaptureSolutionRevision
        },
        {
            no: 6,
            name: "assumptions",
            kind: "message",
            T: CaptureSolutionHandoffAssumption,
            repeated: true
        },
        {
            no: 7,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureSolutionHandoffRequest
 */ export class CreateCaptureSolutionHandoffRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureSolutionHandoffRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureSolutionHandoffRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureSolutionHandoffRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureSolutionHandoffRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * Reuse only for retries of this exact selection, reason and actor.
   *
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string solution_revision_id = 4;
   */ _define_property(this, "solutionRevisionId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionAssumptionVersion assumption_versions = 5;
   */ _define_property(this, "assumptionVersions", []), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureSolutionHandoffRequest, "runtime", proto3);
_define_property(CreateCaptureSolutionHandoffRequest, "typeName", "mono.projectdata.v1.CreateCaptureSolutionHandoffRequest");
_define_property(CreateCaptureSolutionHandoffRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "solution_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "assumption_versions",
            kind: "message",
            T: CaptureSolutionAssumptionVersion,
            repeated: true
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureSolutionHandoffResponse
 */ export class CreateCaptureSolutionHandoffResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureSolutionHandoffResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureSolutionHandoffResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureSolutionHandoffResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureSolutionHandoffResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureSolutionHandoff handoff = 1;
   */ _define_property(this, "handoff", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureSolutionHandoffResponse, "runtime", proto3);
_define_property(CreateCaptureSolutionHandoffResponse, "typeName", "mono.projectdata.v1.CreateCaptureSolutionHandoffResponse");
_define_property(CreateCaptureSolutionHandoffResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "handoff",
            kind: "message",
            T: CaptureSolutionHandoff
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureSolutionHandoffsRequest
 */ export class ListCaptureSolutionHandoffsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionHandoffsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionHandoffsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionHandoffsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionHandoffsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionHandoffsRequest, "runtime", proto3);
_define_property(ListCaptureSolutionHandoffsRequest, "typeName", "mono.projectdata.v1.ListCaptureSolutionHandoffsRequest");
_define_property(ListCaptureSolutionHandoffsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureSolutionHandoffsResponse
 */ export class ListCaptureSolutionHandoffsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureSolutionHandoffsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureSolutionHandoffsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureSolutionHandoffsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureSolutionHandoffsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Newest first; each result resolves immutable source versions, never head.
   *
   * @generated from field: repeated mono.projectdata.v1.CaptureSolutionHandoff handoffs = 1;
   */ _define_property(this, "handoffs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureSolutionHandoffsResponse, "runtime", proto3);
_define_property(ListCaptureSolutionHandoffsResponse, "typeName", "mono.projectdata.v1.ListCaptureSolutionHandoffsResponse");
_define_property(ListCaptureSolutionHandoffsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "handoffs",
            kind: "message",
            T: CaptureSolutionHandoff,
            repeated: true
        }
    ]));
